import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ColumnTable } from 'src/app/models/column-table';
import { Filter } from 'src/app/models/filter';
import { InvoiceWithpayment } from 'src/app/models/invoice-without-payment';
import { Paging } from 'src/app/models/page';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { ParamsService } from 'src/app/services/params.service';

@Component({
  selector: 'pos-invoice-without-payment',
  templateUrl: './invoice-without-payment.component.html',
  styleUrls: ['./invoice-without-payment.component.sass']
})
export class InvoiceWithoutPaymentComponent implements OnInit {

  invoiceWithOutPayments: Paging<InvoiceWithpayment[]> = new Paging([]);

  constructor(private invoiceService: InvoiceService,
    private configurationService: ConfigurationService,
    private paramService: ParamsService,
    private router: Router,
    private bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
    //this.getOrderData({ page: 0, pageSize: 10, value: {} });
  }

  zeroPad(input: number, width: number) {
    return input.toLocaleString('en-US',
      {
        style: 'decimal',
        minimumIntegerDigits: width,
        useGrouping: false
      });
  }

  getTableColumns(): Array<ColumnTable> {

    return [
      new ColumnTable('_id', "Codigo"),
      new ColumnTable('salesOrg', "Sociedad"),
      new ColumnTable('branchCode', "Tienda"),
      new ColumnTable('orderCode', "Orden"),
      new ColumnTable('createdBy', "Creado por"),
      new ColumnTable('fullNumber', "Número Fiscal",),
      new ColumnTable('orderType', "Tipo", { type: "badge", valueMap: this.getTypeMap() }),
      new ColumnTable("timeStamp", "Fecha", { type: "date" })
    ];
  }

  private getTypeMap(): Map<string, string> {
    let result = new Map<string, string>();

    result.set("REGULAR", "Regular");
    result.set("QUOTATION", "Cotización");
    result.set("REPAIRSHOP", "Taller");
    return result;
  }

  async getData(filter: Filter<any>): Promise<void> {


    this.invoiceWithOutPayments = (await this.invoiceService.readInvoiceWithoutPayments(
      filter,
      this.configurationService.readSelectedBranchAndSalesOrg().salesOrg.code,
      this.configurationService.readSelectedBranchAndSalesOrg().branch.code)
    ).response;
  }

  exit() {
    this.bsModalRef.hide();
  }

  goToOrder(invoiceWithpayment: InvoiceWithpayment) {
    this.router.navigate(["orders", invoiceWithpayment.orderCode]);
    this.exit();
  }

}
